export default {
  namespaced: true,
  actions: {
    getState (_, { campaignID, features = [], emitterID }) {
      return this.$api
        .getCampaignState(campaignID, buildFeatureList(features), { emitterID })
        .then(res => res.data)
        .then(state => hydrateState(state))
    },
    hydrateState (_, state) {
      return hydrateState(state)
    },
    getEquipment ({ commit, rootGetters }, { campaignID }) {
      return this.$api
        .getCampaignEquipment(campaignID)
        .then(res => Object.freeze(res.data))
        .then(equipment => {
          const campaign = rootGetters['environment/getCampaign'](campaignID)
          if (!campaign) return equipment
          commit('environment/updateCampaign', { ...campaign, equipment }, { root: true })
          return equipment
        })
    }
  }
}

const hydrateFieldID = fieldID => fieldID.includes('-') ? fieldID : `${fieldID}-0`

const featureMap = {
  campaignState: { key: 's' },
  activeDevices: {
    key: 'a',
    hydrate: input => input
      .split('|')
      .map(d => d.split(','))
      .reduce((acc, [emitterID, deviceID, recordedStamp]) => {
        acc[emitterID] = acc[emitterID] || []
        acc[emitterID].push({ deviceID, recordedStamp })
        return acc
      }, {})
  },
  finishedFields: {
    key: 'f',
    hydrate: input => input
      .split('|')
      .filter(Boolean)
      .map(hydrateFieldID)
  },
  activeOperators: {
    key: 'o',
    hydrate: input => input
      .split('|')
      .filter(Boolean)
      .map(d => d.split(','))
      .map(([emitterID, gpsLat, gpsLng, timestamp]) => Object.freeze({
        emitterID,
        gpsLat: Number(gpsLat),
        gpsLng: Number(gpsLng),
        timestamp: Number(timestamp)
      }))
  },
  tour: {
    key: 't',
    hydrate: input => (input && (([emitterID, tourNumber, started, area, fieldCount]) => Object.freeze({
        emitterID,
        tourNumber: Number(tourNumber),
        started: new Date(Number(started)),
        area: Number(area),
        fieldCount: Number(fieldCount)
      }))(input.split(','))) || null
  },
  activeManualWork: {
    key: 'm',
    hydrate: input => input
      .split('|')
      .map(d => d.split(','))
      .map(([emitterID, ...fields]) => fields
        .map(d => d.split(':'))
        .map(([fieldID, startedAt]) => Object.freeze({
          emitterID,
          fieldID: hydrateFieldID(fieldID),
          startedAt: Number(startedAt)
        }))
      )
      .flat()
  }
}
const buildFeatureList = features => features.map(d => featureMap[d]?.key).filter(Boolean).join('')

const hydrateState = state => {
  const output = {}
  for (const key in state) {
    const [featureKey, { hydrate }] = Object.entries(featureMap).find(([_, { key: featureKey }]) => key === featureKey)
    if (!featureKey) continue
    output[featureKey] = Object.freeze(hydrate ? hydrate(state[key]) : state[key])
  }
  return Object.freeze(output)
}
